import { render, staticRenderFns } from "./userinfor.vue?vue&type=template&id=b3f52874&scoped=true&"
import script from "./userinfor.vue?vue&type=script&lang=js&"
export * from "./userinfor.vue?vue&type=script&lang=js&"
import style0 from "./userinfor.vue?vue&type=style&index=0&id=b3f52874&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f52874",
  null
  
)

export default component.exports